module.exports = __webpack_public_path__ + "img/cajachica.2694f198.png";